module.exports = __webpack_public_path__ + "9b631e3fb3cdae06e94cdd20f2115229.svg";